import React from "react";

export const Sidebar = ({
  title,
  price,
  activeProduct,
  legPrice,
  setVisible,
}) => {
  let activeItem = "Nije odabrano";
  switch (activeProduct.name) {
    case "full":
      activeItem = "Komplet sto";
      break;
    case "board":
      activeItem = "Ploča";
      break;
    case "legs":
      activeItem = "Noge";
      break;
    default:
      activeItem = "Nije odabrano";
  }
  return (
    <>
      <div
        className="configurator-sidebar__exit"
        onClick={() => {
          setVisible(false);
          document.body.classList.remove("stop-scroll");
        }}
      >
        <span></span>
        <span></span>
      </div>
      <p class="configurator-sidebar__title poppins-20-600">{title}</p>
      <p class="configurator-sidebar__title poppins-20-600">Predmet</p>
      <div className="configurator-sidebar__none-wrap">
        <p class="configurator-sidebar__none poppins-16-400">{activeItem}</p>
        {activeProduct.oblik && (
          <p className="configurator-sidebar__none poppins-16-400">
            Oblik: {activeProduct.oblik}
          </p>
        )}
      </div>
      {activeProduct.dims && (
        <>
          <p class="configurator-sidebar__text poppins-16-400">Dimenzije</p>
          <div class="configurator-sidebar__bg">
            {Object.entries(activeProduct.dims).map(([key, item]) => (
              <p className="poppins-14-400" key={key}>
                {item.name}
              </p>
            ))}
          </div>
        </>
      )}
      {activeProduct.legs && Object.keys(activeProduct.legs) != 0 && (
        <>
          <p class="configurator-sidebar__text poppins-16-400">Noge</p>
          <div class="configurator-sidebar__bg">
            {Object.entries(activeProduct.legs).map(([key, value]) => (
              <p className="poppins-14-400" key={key}>
                {key}: {value}
              </p>
            ))}
          </div>
        </>
      )}
      {activeProduct.board && Object.keys(activeProduct.board) != 0 && (
        <>
          <p class="configurator-sidebar__text poppins-16-400">Ploča</p>
          <div class="configurator-sidebar__bg">
            {Object.entries(activeProduct.board).map(
              ([key, value]) =>
                value && (
                  <p className="poppins-14-400" key={key}>
                    {key}: {value}
                  </p>
                )
            )}
          </div>
        </>
      )}

      <p class="configurator-sidebar__price poppins-20-600">
        <span>Cena </span>
        <span class="configurator-sidebar__price-number | js-configurator-price">
          {parseInt(price) + parseInt(legPrice)} €
        </span>
      </p>
    </>
  );
};
